export * from './Cache';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/apollo-cache/lib/types/index.js
// module id = 1432
// module chunks = 0